import { Directive, ElementRef, Output, EventEmitter, OnInit, NgZone } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective implements OnInit {
    serVal: any;
    constructor(private _elementRef: ElementRef, private ngZone: NgZone, private utilitiesService: UtilitiesService) {
    }
    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();

    ngOnInit() {
        this.serVal = this.utilitiesService.documentClickedTarget
            .subscribe(target => {
                this.documentClickListener(target)
            })
    }
    documentClickListener(event: any): void {
        // this.ngZone.runOutsideAngular(() => {
            let targetElement =  event['target'];
            if (!targetElement) {
                return;
            }
            const clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                // this.ngZone.run(() => {
                    this.clickOutside.emit(event);
                // });
            }
        // })
    }
    ngOnDestroy() {
        this.serVal.unsubscribe();
    }
}
